module.exports = __webpack_public_path__ + "static/gazer-bbecdbd197d59324d2709708eafe43bd.jpeg";